import {Component, Input, OnChanges, SimpleChange} from '@angular/core';
import {Facility} from "../../core/facilities/facilities.service";

@Component({
    selector: 'my-notification-facility-list',
    styleUrls: ['notification-facility-list.component.scss'],
    templateUrl: 'notification-facility-list.component.html'
})

export class NotificationFacilityListComponent implements OnChanges {

    @Input() promptText: string;
    @Input() facilities: Facility[];

    isLoading: boolean = false;

    ngOnChanges(changes: {[propName: string]: SimpleChange}) {
        let facilitiesChanged = changes['facilities'];
        if(facilitiesChanged){
            this.facilities = facilitiesChanged.currentValue ? facilitiesChanged.currentValue : [];
        }
    }
}